export default __webpack_public_path__ + "static/media/download_grey.2eaa1bee.svg";